<template>
  <div>
    <offerAcceptOrReject 
      v-if="OfferAcceptModalOpen" 
      @close="OfferAcceptModalOpen = false"
    />
    <BidAcceptOrReject 
      v-if="bidAcceptModalOpen" 
      @close="bidAcceptModalOpen = false"
    />
    <offerPriceChange 
      v-if="OfferPriceChangeModalOpen" 
      @close="OfferPriceChangeModalOpen = false"
    />
    <TmcFirmOrder 
      v-if="tmcFirmOrderModalOpen" 
      v-bind:bidwantedId="bidwantedId"
      @close="tmcFirmOrderModalOpen = false"
    />
    <audio id="offersound">
      <source src="https://imsalarmsounds.s3.amazonaws.com/TF016.WAV" type="audio/ogg">
    </audio>
    <audio id="arbssound">
      <source src="https://imsalarmsounds.s3.amazonaws.com/TF032.WAV" type="audio/ogg">
    </audio>
    <audio id="autobiddersound">
      <source src="https://imsalarmsounds.s3.amazonaws.com/TF039.WAV" type="audio/ogg">
    </audio>
  </div>
</template>

<script>
import authService from "@/authService";
import config from "@/config";
import offerAcceptOrReject from "../ims/Ims-notifications/ImsOfferAcceptorReject";
import offerPriceChange from "../ims/Ims-notifications/ImsOfferPriceChange";
import BidAcceptOrReject from "../autobidder/BidAcceptorRejectModal";
import TmcFirmOrder from "../common/TmcFirmOrderModal";

export default {
  components : {
    offerAcceptOrReject,
    offerPriceChange,
    BidAcceptOrReject,
    TmcFirmOrder
  },
  data() {
    return {
      OfferAcceptModalOpen : false,
      OfferPriceChangeModalOpen : false,
      fcmToken : null,
      bidAcceptModalOpen : false,
      tenantName : null,
      isBrokerDealer : false,
      tmcFirmOrderModalOpen : false,
      bidwantedId : null
    };
  },
  methods: {
    checkForPricechangedOffers(){
         const auth = {
            headers: {'org-token' : authService.getOrgToken() }
         };
         this.$http
         .get(
            config.baseUrlBidSide +
            "/offer/listall?page=1&size=10&search=&status=PRICE_CHANGE&sortColumn=latestDate&sortOrder=DESC&cognitoSub="+
            authService.getUser().cognitoSub+
            "&cusips="+
            "&accountMappingIds=",
            auth
         )
         .then(result => {
            if(result.data.content.length > 0){
              this.OfferPriceChangeModalOpen = true;
              this.playSound('offersound')
            }
         })
    },
    saveToken(){
      let cognitoSub = authService.getUser().cognitoSub;         
      const auth = {
          headers: { 'org-token' : localStorage.getItem("org-token") }
      };
      let tokenObj =  {
          "fcmToken": this.fcmToken ,
          "cognitoSub": cognitoSub
      }
      this.$http
      .post(
        config.baseUrlBidSide +
          "/fcm/fcm-register",
          tokenObj,
          auth
      )
      .then(() => {
        
      })
    },
    deleteToken(){
      this.$messaging.deleteToken();
    },
    showOfferNotification(response){
    // console.log("messgae:",response.data);
      let cognitoSub = authService.getUser().cognitoSub;
      //Only active tab need to show order alers.
      if(!document.hidden || response.backgroundMessage){
        if(response.data.message == 'NEW ORDER RECIEVED' || response.data.message == 'ORDER CANCELLED' || response.data.message ==  'ARBS ORDER CANCELLED' ){
          if(!this.OfferAcceptModalOpen){
            //if offer accept popup is hidden
            this.OfferAcceptModalOpen = true;
            this.playSound('offersound');
          }else{
            //if offer accept popup is visible refresh data
            this.$root.$emit("orderrefresh");  
            this.playSound('offersound');
          }
        }
        if(response.data.message == 'NEW ARBS ORDER RECIEVED'){
          if(!this.OfferAcceptModalOpen){
            //if offer accept popup is hidden
            this.OfferAcceptModalOpen = true;
            this.playSound('arbssound');
          }else{
            //if offer accept popup is visible refresh data
            this.$root.$emit("orderrefresh");  
            this.playSound('arbssound');
          }
        } 
        if(response.data.message == 'NEW AUTOBIDDER ORDER RECEIVED'){
          if(!this.bidAcceptModalOpen){
            //if offer accept popup is hidden
            this.bidAcceptModalOpen = true;
            this.playSound('autobiddersound');
          }else{
            //if offer accept popup is visible refresh data
            this.$root.$emit("orderrefresh");  
            this.playSound('autobiddersound');
          }
        } 
        if(response.data.type == 'FIRM_ORDER_SUCCESS'){
            this.bidwantedId = response.data.message
            this.tmcFirmOrderModalOpen = true;
            this.playSound('autobiddersound');
          
        } 
        if(response.data.type == 'OFFERING_FEED_VIEW_STATUS'){
          this.$root.$emit("offeringfeedstatus",{status :response.data}); 

        }
      }
     
      if(cognitoSub === response.data.cognitoSub){
        if(response.data.status == 'SUCCESS'){
            this.$notify({
              group: 'foo',
              type: 'success',
              title: '',
              text: response.data.message,
              duration: 10000,
            });
        }
        if(response.data.status == 'FAIL'){
            this.$notify({
              group: 'foo',
              type: 'error',
              title: '',
              text: response.data.message,
              duration: 10000,
            });
        }
   
        if(response.data.status == 'WARNING'){
            this.$notify({
              group: 'foo',
              type: 'error',
              title: '',
              text: response.data.message,
              duration: 10000,
            });
        }
        if(response.data.status == 'ALERT_SUCCESS'){
          // this.$alert(response.data.message,"","success");
          this.$fire({type: 'success',html: response.data.message});
          if(response.data.type == 'SETTING_CHANGED_ALERT'){
            this.playSound('offersound');
          }
        }
        if(response.data.status == 'ALERT_ERROR'){
          // this.$alert(response.data.message,"","error");
          this.$fire({type: 'error',html: response.data.message})

        }
        if(response.data.status == 'ALERT_WARNING'){
          // this.$alert(response.data.message,"","warning");
          this.$fire({type: 'info',html: response.data.message})

        }
        if(response.data.bidupdated){
          this.$root.$emit("bidupdated"); 
        }
        if(response.data.type == 'INVENTORY_ACCOUNT_HOLDING_FILE' || response.data.type == 'HOLDING_FILE' ){
          //INVENTORY_ACCOUNT_HOLDING_FILE" / "HOLDING_FILE
          localStorage.removeItem("INVUPLOADSTATUS");
          this.$root.$emit("INVUPLOADCOMPLETED"); 
        }
        if(response.data.type == 'OFFER_UPLOAD'){
          //INVENTORY_ACCOUNT_HOLDING_FILE" / "HOLDING_FILE
          localStorage.removeItem("OFFERUPLOADSTATUS");
          this.$root.$emit("OFFERUPLOADCOMPLETED"); 
        }
        if(response.data.type == 'SPREAD_CHANGE'){
          //price change import success
          localStorage.removeItem("SPREADUPLOADSTATUS");
          this.$root.$emit("SPREADUPLOADCOMPLETED"); 
        }
        if(response.data.type == 'ARBS_FILE_PROCESSED'){
          this.$root.$emit("ARBS_FILE_PROCESSED"); 
        }
        if(response.data.type == 'ARBS_FEED_FILE_PROCESSED'){
          this.$root.$emit("ARBS_FILE_PROCESSED"); 
        }
        //
        if(response.data.type == 'ARBS_FEED_OFFER_UPDATED'){
          localStorage.removeItem("ARBSUPLOADSTATUS");
          this.$root.$emit("ARBS_OFFER_UPDATED"); 
        }
        if(response.data.type == 'ARBS_OFFER_UPDATED'){
          localStorage.removeItem("ARBSUPLOADSTATUS");
          this.$root.$emit("ARBS_OFFER_UPDATED"); 
        }
        //
        
        if(response.data.type == 'ARBS_FILE_UPLOAD'){
          localStorage.removeItem("ARBSUPLOADSTATUS");
          this.$root.$emit("ARBSUPLOADCOMPLETED"); 
        }
        if(response.data.type == 'ARBS_FEED_FILE_UPLOAD'){
          localStorage.removeItem("ARBSUPLOADSTATUS");
          this.$root.$emit("ARBSUPLOADCOMPLETED"); 
        }
        
        if(response.data.type == 'PLFILEUPLOADSTATUS'){
          localStorage.removeItem("PLUPLOADSTATUS");
          this.$root.$emit("PLUPLOADCOMPLETED"); 
        }
        if(response.data.type == 'TICKET_CATALOGUE_STATUS_COMPLETE'){
          localStorage.removeItem("TICKETING_PROCESS");
          this.$root.$emit("TICKETINGPROCESSCOMPLETED"); 
        }
        if(response.data.type == 'COMPLIANCE_NOTIFICATION'){
          this.$root.$emit("compliancenotification",{count :response.data.count}); 
        }
        if(response.data.type == 'ARBS_FEED_SUMMARY'){
          this.$root.$emit("arbsfeedcount",{count :response.data.message}); 
        }
        if(response.data.type == 'OFFERING_FEED_SUMMARY'){
          this.$root.$emit("offeringfeedcount",{count :response.data.message}); 
        }
        if(response.data.type == 'suggestPrice'){
          this.$root.$emit("bidwantedrefresh"); 
        }
        if(response.data.type == 'INVENTORY_HOLDING_TOTALS'){
          this.$root.$emit("INVENTORY_HOLDING_TOTALS",{count :response.data}); 
        }

        if(response.data.type == 'OFFERING_FEED_PREVIEW_COUNT'){
          this.$root.$emit("offeringfeedpreviewcount",{count :response.data}); 
        }

        if(response.data.type == 'OUTLOOK_EMAIL_FETCHER_ZIP'){
         const zipKey = response.data.zipKey;
          // Use a key to store downloaded zip keys
          let downloadedKeys = JSON.parse(localStorage.getItem('downloadedZipKeys') || '[]');
          // Only download if not already downloaded and only in the focused tab
          if (!downloadedKeys.includes(zipKey) && !document.hidden) {
              this.downloadFile(zipKey);
              this.$notify({
                group: 'foo',
                type: 'success',
                title: '',
                text: "Trade File downloaded successfully",
                duration: 10000,
              });
              downloadedKeys.push(zipKey);
              localStorage.setItem('downloadedZipKeys', JSON.stringify(downloadedKeys));
          }
        }

        
      }

    },
     downloadFile(downloadKey){
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .post(
           config.baseUrlBidSide +
            "/fileupload/get-file",{
                    "key":downloadKey
                },
            auth
        )
        .then((response) => {
          window.open(response.data, "_blank");
       
        })
        .catch(e => {
          console.log(e);
          

        });
    },
    playSound(element){
         var x = document.getElementById(element); 
         var promise =  x.play();
         var self = this;
         if (promise !== undefined) {
            promise.then(()=> {
               // Autoplay started!
            }).catch(error => {
               self.$alert("Please allow sound/audio access to this site from your browser settings page to enable the sound feature.","","warning");
               console.log("error",error)
               // Autoplay was prevented.
               // Show a "Play" button so that user can start playback.
            });
         } 
      }
  },
  created() {
    this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          this.tenantName = role[0].split("-")[0];
          // this.tenantName.toLowerCase() === "newedge" ? this.isBrokerDealer = true : this.isBrokerDealer = false;
          let isBrockerDealer  = window.location.pathname.includes('brockerdealer');
          if(!isBrockerDealer){
            this.checkForPricechangedOffers();
          }
        }
      });
  },
  mounted() {
    const messaging = this.$messaging;
    var self = this;
    // Let's check if the browser supports notifications
    if (!("Notification" in window)) {
      alert("This browser does not support desktop notification");
    }
    messaging
      .requestPermission()
      .then(function () {
        console.log("Have permission");
        return messaging.getToken();
      })
      .then(function (token) {
        console.log("token", token);
        self.fcmToken = token;
        localStorage.setItem('fcmtoken', token);
        self.saveToken();
      })
      .catch(function (err) {
        console.log("Error occured", err);
        //self.$alert("Please allow notification access to this site from your browser settings page to receive notification from ECN's.","","warning");
        authService.removeFcmToken();

      });
    navigator.serviceWorker.addEventListener("message", (event) => {
      this.showOfferNotification(event.data);
    });
    this.$root.$on("showofferacceptpopup", () => {
        this.OfferAcceptModalOpen = true;
    });
    this.$root.$on("showoautobidderacceptpopup", () => {
        this.bidAcceptModalOpen = true;
    });
    
  },
};
</script>
